import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateUserByIdApi } from '@src/api';
import { NewUserData } from '@src/api/users/usersApi';
import { DefaultRole } from '@src/types/common';

interface UpdateUserThunkArg extends NewUserData {
  id: number;
}

interface ResponseData {
  id: number;
  name?: string;
  email?: string;
  role?: DefaultRole;
  passwd?: string;
}

const updateUserThunk = createAsyncThunk(
  'users/updateUserThunk',
  async (
    { id, name, email, role, passwd }: UpdateUserThunkArg,
    { rejectWithValue }
  ) => {
    try {
      const response = await updateUserByIdApi<
        UpdateUserThunkArg,
        ResponseData
      >(id, {
        id,
        name,
        email,
        role,
        passwd,
      });

      return response.result;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export default updateUserThunk;
